export var accordionTheme = {
  baseStyle: {
    container: {
      borderTop: 'surface.default',
      ':last-of-type': {
        borderBottom: 'surface.default'
      }
    },
    button: {
      height: 'auto',
      minHeight: '56px',
      padding: 's',
      paddingBottom: 's',
      paddingTop: 's',
      paddingInlineStart: 's',
      paddingInlineEnd: 's',
      outlineOffset: 0,
      _hover: {
        backgroundColor: 'neutral.lightest'
      },
      _focus: {
        boxShadow: 'none'
      },
      _focusVisible: {
        outlineColor: 'focus.focus',
        transition: 'outline-color 0.2s ease 0s'
      }
    },
    title: {
      flex: '1',
      textAlign: 'left',
      textStyle: 'body2',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      marginRight: 'm'
    },
    panel: {
      textStyle: 'body3',
      paddingInlineStart: 's',
      paddingInlineEnd: 's',
      paddingBottom: 's',
      paddingTop: 's'
    }
  }
};
//# sourceMappingURL=Accordion.theme.js.map